import executeRequest, { RequestOutput } from 'app/api'
import { APIPaginatable, APIPaginatableResponse, APISortable, APISearchable } from 'app/api/types'
import { API_Policy } from 'app/api/project/policies'

enum APIEndpoint {
  GetAllRiskNotices = 'api/riskNotices',
  GetRiskNoticeById = 'api/riskNotices/getById',
  CreateRiskNotice = 'api/riskNotices/create',
  UpdateRiskNotice = 'api/riskNotices/update',
  DeleteRiskNotice = 'api/riskNotices/delete',
  UpdateRiskNoticeStatus = 'api/riskNotices/updateStatus',
}

export interface API_RiskNotice {
  id: number
  creationDate?: Date | null
  riskNoticeNumber?: string | null
	riskNoticeStatus?: API_RiskNoticeStatus | null
	contractorName?: string | null
	contractorAddress?: string | null
	contractorZip?: string | null
	contractorCity?: string | null
	contractorFiscalCode?: string | null
	email?: string | null
	insuredName?: string | null
	insuredAddress?: string | null
	insuredZip?: string | null
	insuredCity?: string | null
	goodsDescription?: string | null
	handlingInformation?: string | null
	routing?: string | null
	container?: string | null
	isGoodsNew?: boolean | null
	coverageStartPlace?: string | null
	coverageStartDate?: Date | null
	dischargingPlace?: string | null
	startingPlace?: string | null
	vectorName?: string | null
	coverageEndPlace?: string | null
	flightNumber?: string | null
	masterAWB?: string | null
	voyager?: string | null
	carrier?: string | null
	billOfLanding?: string | null
	vessel?: string | null
	insuredAmount?: number | null
	insuredAmountCurrency?: string | null
	incoterms?: string | null
	parcels?: string | null
	notes?: string | null
	internalNotes?: string | null
  riskNoticeType?: API_RiskNoticeType | null
  policy?: API_Policy
}
export interface API_RiskNoticeType {
  id: number
  name?: string | null
  keyword?: string | null
}
export interface API_RiskNoticeStatus {
  id: number
  name?: string | null
  keyword?: string | null
}



export interface GetAllRiskNoticesRequestParams extends APIPaginatable, APISortable, APISearchable {
}
export interface GetAllRiskNoticesResponse extends APIPaginatableResponse {
  riskNotices: API_RiskNotice[]
}
enum GetAllRiskNoticesResponseError {
}
export async function getAllRiskNotices(params: GetAllRiskNoticesRequestParams, output?: RequestOutput<GetAllRiskNoticesResponse, GetAllRiskNoticesResponseError>) {
  executeRequest({
    endpoint: APIEndpoint.GetAllRiskNotices,
    params: params,
    output: output,
  })
}



export type GetRiskNoticeRequestParams = {
  id: number
}
export type GetRiskNoticeResponse = {
  riskNotice: API_RiskNotice
}
enum GetRiskNoticeResponseError {
}
export async function getRiskNotice(params: GetRiskNoticeRequestParams, output?: RequestOutput<GetRiskNoticeResponse, GetRiskNoticeResponseError>) {
  executeRequest({
    endpoint: APIEndpoint.GetRiskNoticeById,
    params: params,
    output: output,
  })
}



export type CreateRiskNoticeRequestParams = {
}
type CreateRiskNoticeResponse = {
  riskNotice: API_RiskNotice
}
enum CreateRiskNoticeReponseError {
}
export async function createRiskNotice(params: CreateRiskNoticeRequestParams, output?: RequestOutput<CreateRiskNoticeResponse, CreateRiskNoticeReponseError>) {
  executeRequest({
    endpoint: APIEndpoint.CreateRiskNotice,
    params: params,
    output: output,
  })
}



export interface UpdateRiskNoticeRequestParams extends API_RiskNotice {
  riskNoticeTypeId?: number | null
  riskNoticeStatusId?: number | null
  policyId?: number | null
}
type UpdateRiskNoticeResponse = {
}
enum UpdateRiskNoticeReponseError {
}
export async function updateRiskNotice(params: UpdateRiskNoticeRequestParams, output?: RequestOutput<UpdateRiskNoticeResponse, UpdateRiskNoticeReponseError>) {
  executeRequest({
    endpoint: APIEndpoint.UpdateRiskNotice,
    params: params,
    output: output,
  })
}



export type DeleteRiskNoticeRequestParams = {
  id: number
}
type DeleteRiskNoticeResponse = {
}
enum DeleteRiskNoticeReponseError {
}
export async function deleteRiskNotice(params: DeleteRiskNoticeRequestParams, output?: RequestOutput<DeleteRiskNoticeResponse, DeleteRiskNoticeReponseError>) {
  executeRequest({
    endpoint: APIEndpoint.DeleteRiskNotice,
    params: params,
    output: output,
  })
}



export type UpdateRiskNoticeStatusRequestParams = {
  id: number
}
type UpdateRiskNoticeStatusResponse = {
}
enum UpdateRiskNoticeStatusReponseError {
}
export async function updateRiskNoticeStatus(params: UpdateRiskNoticeStatusRequestParams, output?: RequestOutput<UpdateRiskNoticeStatusResponse, UpdateRiskNoticeStatusReponseError>) {
  executeRequest({
    endpoint: APIEndpoint.UpdateRiskNoticeStatus,
    params: params,
    output: output,
  })
}